<template>
    <v-dialog width="auto">
        <template v-slot:activator="{ props }">
            <v-fab  
            v-bind="props" color="pink-darken-2" dark size="default" icon="mdi-arrow-right" 
            >
           </v-fab>
        </template>

        <template v-slot:default="{ isActive }">
            <v-card theme="dark">
                <v-card-item>
                    <v-card-title>Spostamento</v-card-title>
                    <v-card-subtitle>Stai per spostare il centro della mappa</v-card-subtitle>
                </v-card-item>
                <v-card-text>

                    <p class="mb-2">
                        <v-select label="Sistema" v-model="selected" :items="items"></v-select>
                    </p>
                    <p class="mb-2" v-if="selected == 250">
                        <v-number-input v-model="data.quadrante" label="Quadrante 250" min="1" max="20125"></v-number-input>
                    </p>
                    <p v-if="selected == 32632"> 
                        <v-number-input v-model="data.est" label="Est"  min="337075" max="417234"></v-number-input>
                        <v-number-input v-model="data.nord" label="Nord"  min="5035034" max="5090091"></v-number-input>
                    </p>
                    <p v-if="selected == 4326"> 

                        <v-number-input v-model="data.longitudine" :step="0.01" label="Longitudine"  min="45.4498351" max="45.9594057"></v-number-input>
                        <v-number-input v-model="data.latitudine" :step="0.01" label="Latitudine"  min="6.9164609" max="7.9319041"></v-number-input>
                    </p>
                </v-card-text>

                <v-card-actions class="flex-column">
                    <v-btn  variant="flat" size="large"  color="pink-darken-2"  
                        
                        @click="applyGoTo(); isActive.value = false">
                        <v-icon class="mr-2">mdi-arrow-right</v-icon>
                        Vai</v-btn>
                    <v-btn  variant="outlined" size="large" color="white" @click="isActive.value = false" >
                        <v-icon>mdi-chevron-down</v-icon>
                        Indietro</v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>
</template>

  
<script setup>
import { ref } from 'vue'


import { useRuntimeStore } from "@/store/runtime"

import { fromLonLat, transform } from 'ol/proj';
// import Projection from 'ol/proj/Projection.js';


import { UTMPNGP250_to_WGS84UTM32 } from '@/components/map/utils/UTMPNGP250'




const runtimeStore = useRuntimeStore();

/* eslint-disable no-unused-vars */
// const prj_32632 = new Projection({ 

//     code: 'EPSG:32632',
//     extent: [166021.44, 0.0, 833978.56, 9329005.18],
//     units: 'm'
// });


const data = ref({
    quadrante: '',
    nord: '',
    est: '',
    latitudine: '',
    longitudine: ''
})

 
const modelValue = defineModel()

const items = [
    {
        title: 'Quadrante 250',
        value: 250
    },
    {
        title: '32632 in metri',
        value: 32632
    },
    {
        title: '4326 in gradi',
        value: 4326
    },
]

const selected = ref(250)

const applyGoTo = () => {
    let new_coords = [0, 0]

    runtimeStore.setFollowFalse()

    switch (selected.value) {
        case 250:
            // console.log("case 250:")
            new_coords = goTo250(data.value.quadrante)
            break;
        case 32632:
            // console.log("case 32632:")
            new_coords = goTo32632([parseInt(data.value.est), parseInt(data.value.nord)])
            break;
        case 4326:
            // console.log("case 4326:")
            new_coords = goTo4326([data.value.longitudine, data.value.latitudine], 'EPSG:3857')
            break;
    }

    // output should be 3857 coordinates
    // console.log(new_coords)

    if (new_coords)
        modelValue.value = new_coords
}

const goTo250 = (quadrante) => {

    let coordinates3587 = null
    const q250to32632 = UTMPNGP250_to_WGS84UTM32(quadrante)
    if (q250to32632.center) {
        coordinates3587 = goTo32632(q250to32632.center)
    }
    return coordinates3587
}

const goTo32632 = (coords) => {
    // console.log(coords)

    let transformed_coords = transform(coords, 'EPSG:32632', 'EPSG:3857')
    transformed_coords = [parseInt(transformed_coords[0]), parseInt(transformed_coords[1])]
    // console.log(transformed_coords)

    return transformed_coords
}

const goTo4326 = (coords, projection) => {
    return fromLonLat(coords, projection)
}


//32632
//3373246,6392387
// =
//3857
//5565974, 6446275 

</script>

<style scoped>
.v-btn {
    pointer-events: auto;
    margin: .3em;
}
</style>

